/**
 * Port of {@class FieldTypeTag} —
 * backend/src/main/java/com/irian/iam/ruleengine/api/ast/FieldTypeTag.java
 *
 * Coarse field-type tag used by {@link ComparisonOperator}.appliesTo to declare
 * which operators apply to a given field shape. Decoupled from the engine
 * registry's vendor-specific TYPE_* string constants so the AST package
 * doesn't depend on the engine package.
 */

export const FieldTypeTag = {
    /** Strings and other text-shaped scalars. */
    SCALAR: 'SCALAR',
    /** Coded enum values (string-shaped but constrained to a value set). */
    ENUM: 'ENUM',
    NUMBER: 'NUMBER',
    BOOLEAN: 'BOOLEAN',
    /** ISO-8601 calendar date (LocalDate) — orderable. */
    DATE: 'DATE',
    /** ISO-8601 instant / timestamp (Instant or OffsetDateTime) — orderable. */
    TIMESTAMP: 'TIMESTAMP',
    /** Collection-valued field (CONTAINS body only). */
    COLLECTION: 'COLLECTION',
    /** Fallback for unrecognised type strings — only universally-applicable operators apply. */
    ANY: 'ANY',
} as const
export type FieldTypeTag = typeof FieldTypeTag[keyof typeof FieldTypeTag]

export const FIELD_TYPE_TAG_VALUES: readonly FieldTypeTag[] = Object.values(FieldTypeTag)
